module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_01@2x-8ec257f6c7813756096cefd03a4d25eb.jpg";